/**
 * s3 에 올린 파일 추적이 어려워서 만들었어요
 */
export const ImageAsset = {
  handmade_thumbnail:
    '//s3.marpple.co/files/u_2232571/2025/4/original/19f416e764e4b0d2c68dd60bb4a9b6213cf5c68d1.png',
} as const;
